<template>
	<v-navigation-drawer
      class='secondary accent-4'
      dark
      v-model='maindrawer'
      absolute
      v-on-clickaway='clickedAway'
    >
    <v-list>
      <v-list-item
        link
        @click='goAdmin(0)'>
        <v-list-item-content>
          <v-list-item-title  ><v-icon>mdi-reply</v-icon>Cambiar condominio</v-list-item-title> 
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        @click='goAdmin(1)'>
        <v-list-item-content>
          <v-list-item-title>Pantalla principal</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group
              v-for="(item, index) in Menus"
              :key='index'
              v-model="item.active"
              :prepend-icon="item.action"
              no-action
            >
              <template v-slot:activator>
                  <v-list-item-title style="color: white;">{{ item.title }}</v-list-item-title>
              </template>
                <v-list-item
                  v-for='(subItem, subIndex) in item.items'
                  :key='subIndex'
                  link
                  @click='goAdmin(subItem.value)'>
                  <v-list-item-content>
                    <v-list-item-title  >{{ subItem.title }}</v-list-item-title> 
                  </v-list-item-content>
                </v-list-item>
            </v-list-group>
    </v-list>
    <template v-slot:append>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Vue from 'vue';
import {mapActions} from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [ clickaway ],
  name: 'DrawerCondominio',
  components: {},
  props: {maindrawer: {type: Boolean, default: true}},
  data() {
    return {
      Menus: [
        {
          title: 'Condominio',
          items: [
            { title: 'Unidades', value: 6 },
            { title: 'Propietarios/Inquilinos', value: 7 },
            { title: 'Conceptos', value: 8 },
            { title: 'Series', value: 11 },
          ],
        },
        {
          title: 'Ingresos',
          items: [
            { title: 'Recibos', value: 2},
            { title: 'Borradores', value: 3},
            { title: 'Recibos Persistentes', value: 4},
            { title: 'Cobros', value: 5},
            { title: 'Ingreso No Reconocido', value: 12},
          ],
        },
        {
          title: 'Catalogos',
          items: [
            { title: 'Cuentas Bancarias', value: 9 },
            { title: 'Cuentas Contables', value: 10 },
          ],
        },
        {
          title: 'Egresos',
          items: [
            { title: 'Egreso', value: 15},
            { title: 'Pagos', value: 13 },
            { title: 'Proveedores', value: 14},
          ],
        },
        {
          title: 'QR',
          items: [
            { title: 'Generar', value: 20 },
            { title: 'Aviso', value: 21 },
          ],
        },
      ],
      menu: null,
    };
  },
  mounted() {
    this.enableDrawer();
  },
  beforeDestroy() {
    this.disableDrawer();
  },
  methods: {
    ...mapActions(['disableDrawer', 'enableDrawer']),
    goAdmin(index) {
      this.$store.dispatch('toggleDrawer');
      switch (index) {
        case 0: this.$router.push({name: 'condominiosSelector'}); break;
        case 1: this.$router.push({name: 'condominio'}); break;
        case 2: this.$router.push({name: 'recibos'}); break;
        case 3: this.$router.push({name: 'loteRecibos'}); break;
        case 4: this.$router.push({name: 'persistentes'}); break;
        case 5: this.$router.push({name: 'cobros'}); break;
        case 6: this.$router.push({name: 'unidades'}); break;
        case 7: this.$router.push({name: 'propietCondomino'}); break;
        case 8: this.$router.push({name: 'conceptos'}); break;
        case 9: this.$router.push({name: 'cuentas'}); break;
        case 10: this.$router.push({name: 'contables'}); break;
        case 11: this.$router.push({name: 'series'}); break;
        case 12: this.$router.push({name: 'noringresos'}); break;
        case 13: this.$router.push({name: 'pagos'}); break;
        case 14: this.$router.push({name: 'proveedores'}); break;
        case 15: this.$router.push({name: 'egreso'}); break;
        case 20: this.$router.push({name: 'generar'}); break;
        case 21: this.$router.push({name: 'aviso'}); break;
      }
    },
    clickedAway() {
      if (this.maindrawer) {
        console.log('Clicked away from drawer');
        this.$store.dispatch('toggleDrawer');
      }
    },
  },
};
</script>

<style scoped lang='scss'>
  @import 'src/styles/style.scss';
</style>
